import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { Card, Form, Icon, Input, Button } from 'antd';
import { isEmpty } from '../../../util/isEmpty';
import PropTypes from 'prop-types';

const { Meta } = Card;

/**
 * @component
 * @category Search Page
 * @name CustomMessage
 * @description This is the custom message card component shown on top of all result cards
 * and below sort by cheaper/faster section
 * **Example**
 * ```js
 *   <CustomMessage/>
 * ```
 */
class CustomMessage extends Component {
  state = {};

  render() {
    const { secondaryColor, searchCustomMsgJSON } = this.props;

    let heading;
    let faIcon;
    let text;
    if (searchCustomMsgJSON && !isEmpty(searchCustomMsgJSON)) {
      heading = searchCustomMsgJSON.heading;
      faIcon = searchCustomMsgJSON.icon;
      text = searchCustomMsgJSON.text;
    }

    return (
      <>
        <Card
          title={
            <div
              style={{
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'start',
                whiteSpace: 'pre-wrap',
              }}
            >
              <i
                style={{
                  fontSize: '28px',
                  color: secondaryColor,
                }}
                className={`${faIcon}`}
              />

              <h1
                style={{
                  color: 'black',
                  marginLeft: '8px',
                }}
              >
                {heading}
              </h1>
            </div>
          }
          style={{
            borderRadius: '5px',
            boxShadow: '0 1px 5px rgba(0, 0, 0, 0.15)',
            background: 'white',
            height: 'auto',
            margin: '0px 0px 15px 0px',
          }}
        >
          {/* show submit message upon success post request */}
          {
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <p
                style={{
                  marginLeft: '10px',
                  display: 'flex',
                  alignItems: 'center',
                }}
                className="testR1"
              >
                {text}
              </p>
            </div>
          }
        </Card>
      </>
    );
  }
}

CustomMessage.propTypes = {
  /**
   * secondary color of web app
   */
  secondaryColor: PropTypes.string,
  /**
   * custom message is shown on top of results cards on search page
   */
  searchCustomMsgJSON: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    // primaryColor: state.code_config.primaryColor,
    secondaryColor: state.code_config.secondaryColor,
    searchCustomMsgJSON: state.code_config.searchCustomMsgJSON,
  };
};

export default connect(mapStateToProps, actions)(CustomMessage);
